// src/auth.ts
var INVALID_TOKEN_STATUS_CODE = 498;
var BASE_COOKIE_OPTIONS = {
  httpOnly: false,
  // Allow JS access to cookie
  secure: true,
  // Cookie only send over HTTPS
  sameSite: "strict",
  // Only send cookie to origin requests
  path: "/"
};
export {
  BASE_COOKIE_OPTIONS,
  INVALID_TOKEN_STATUS_CODE
};
//# sourceMappingURL=auth.mjs.map